export type SitemapTabName =
  | 'categories'
  | 'brands'
  | 'youtubers'
  | 'country'
  | 'website';

export type SitemapUrlParams = {
  tab: SitemapTabName;
  page: number;
  size: number;
  id?: number | string;
  keyword?: string; // selected or # or a-z
  website?: string;
  country?: string;
  invalidUrl?: boolean;
};

export const encodeSitemapUrl = (params: Partial<SitemapUrlParams>) => {
  const parts: string[] = [];
  if (params.tab) {
    parts.push(params.tab);
    if (params.tab === 'country') {
      parts.unshift('youtubers');
      if (params.country) {
        parts.push(encodeURIComponent(params.country));
      }
    } else if (params.tab === 'website') {
      parts.unshift('youtubers');
      if (params.website) {
        parts.push(encodeURIComponent(params.website));
      }
    }
  } else {
    parts.push('categories');
  }

  if (
    !params.tab ||
    ['categories', 'brands', 'youtubers'].includes(params.tab)
  ) {
    if (!params.keyword || params.keyword === 'selected') {
      parts.push('selected');
    } else {
      parts.push('name');
      if (params.keyword === '#' || params.keyword === 'other') {
        parts.push('other');
      } else if (/^[a-z]$/.test(params.keyword)) {
        parts.push(params.keyword.toLowerCase());
      } else {
        parts.push('a');
      }
    }
  }

  parts.push(`${params.page || 1}`);
  parts.push(`${params.size || 100}`);

  let url = parts.join('-');

  if (params.id) {
    url = `${url}?id=${params.id}`;
  }

  return `/sitemap/${url}`;
};
